import React from 'react';
import { StarIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-200" data-mp="3mgsks6m6b79w">
      <div className="mx-auto w-full max-w-4xl" data-id="element-201" data-mp="3mfhg84kwlvhq">
        <div className="mx-auto max-w-2xl text-center" data-id="element-202" data-mp="3r80ul3rf0unl">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-gold-dark" data-id="element-203" data-mp="3r9loqs9tibkx">
            Testimonianze
          </p>
          <h2 className="mt-3 font-display text-[26px] font-bold leading-[1.15] text-ink sm:text-4xl" data-id="element-204" data-mp="42jb7j998cgp">
            ⭐ Cosa dicono altri odontoiatri
          </h2>
          <div className="mt-4 flex items-center justify-center gap-2" data-id="element-205" data-mp="92p5l76wsd2h">
            <span className="flex" aria-hidden="true" data-id="element-206" data-mp="dzxo58vyyj49">
              {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-5 w-5 fill-gold-dark text-gold-dark" data-id="element-207" data-mp="2aukfbh9lu7i2" />)}
            </span>
            <span className="font-display text-xl font-bold text-ink" data-id="element-208" data-mp="1sl2nlxb0rw13">4.9/5</span>
          </div>
          <p className="mt-2 text-[14px] text-ink/60" data-id="element-209" data-mp="1ntatxdwkha6q">
            Più di 1.200 odontoiatri usano già Protocollo Clinico Sicuro™
          </p>
        </div>

        <ul className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-210" data-mp="1isn42vk2qze3">
          {testimonials.map(testimonial => <li key={testimonial.name} className="flex flex-col rounded-2xl border border-ink/10 bg-white p-5" data-id="element-211" data-mp="1er1m4vsonux1">
              <div className="flex items-center gap-3" data-id="element-212" data-mp="26lddax0lf4ko">
                <img src={testimonial.photo} alt={`Foto di ${testimonial.name}`} className="h-12 w-12 shrink-0 rounded-full object-cover" width={96} height={96} data-id="element-213" data-mp="22ip3on421tmn" />
                <div className="min-w-0" data-id="element-214" data-mp="r4v2tddt6sri">
                  <p className="text-[14px] font-bold leading-tight text-ink" data-id="element-215" data-mp="m4qitddozfwj">
                    {testimonial.name} <span aria-hidden="true" data-id="element-216" data-mp="nlvzewt3hkhb">{testimonial.flag}</span>
                  </p>
                  <p className="text-[12.5px] leading-tight text-ink/55" data-id="element-217" data-mp="skpakikwszeb">
                    {testimonial.country}
                  </p>
                </div>
              </div>
              <span className="mt-3 flex" aria-hidden="true" data-id="element-218" data-mp="en0qhcyo1wab">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-3.5 w-3.5 fill-gold-dark text-gold-dark" data-id="element-219" data-mp="iodztx0ywhlz" />)}
              </span>
              <p className="mt-3 text-[14.5px] leading-relaxed text-ink/70" data-id="element-220" data-mp="9nxyat3sbkjr">
                “{testimonial.quote}”
              </p>
            </li>)}
        </ul>

        <div className="mx-auto mt-9 max-w-md" data-id="element-221" data-mp="3w1z5wz8h1342">
          <CTAButton label="Voglio sentirmi altrettanto sicuro" data-id="element-222" data-mp="3i1wrjmzdgrtk" />
        </div>
      </div>
    </section>;
}